export default "__VITE_ASSET__H1t5dQMt__"